import { may, type CanHolder } from "../../lib/access";

/**
 * Betriebslog affordances. Each names its operation of the rights matrix
 * ([F-027]) and asks the server's answer - the SPA never mirrors the matrix.
 * Reading needs nothing: every role reads the Betriebslog (PO-050 option 1).
 */

/** May record an entry (`oplog.write`, from `/me.can`). */
export function canWriteOperationsLog(user: CanHolder | null | undefined): boolean {
  return may(user, "oplog.write");
}

/** May link this incident to an entry (`oplog.link`, from the incident's `can`). */
export function canLinkOperationsLog(incident: CanHolder): boolean {
  return may(incident, "oplog.link");
}
